import React, { useEffect, useRef } from "react";

export default function Dialog({ title, children, onClose }) {
  const dialogRef = useRef(null);
  const previous = useRef(undefined);
  if (previous.current === undefined) previous.current = document.activeElement;

  useEffect(() => {
    const node = dialogRef.current;
    const focusable = node?.querySelector("button, [href], input, textarea, select, [tabindex]:not([tabindex='-1'])");
    focusable?.focus();
    function onKey(event) {
      if (event.key === "Escape") {
        event.stopPropagation();
        onClose();
      }
      if (event.key !== "Tab" || !node) return;
      const items = [...node.querySelectorAll("button, [href], input, textarea, select, [tabindex]:not([tabindex='-1'])")];
      if (items.length === 0) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("keydown", onKey);
      previous.current?.focus?.();
    };
  }, [onClose]);

  return (
    <div className="rr-dialog-backdrop" onMouseDown={onClose}>
      <div
        className="rr-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="rr-dialog-title"
        ref={dialogRef}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <h2 id="rr-dialog-title">{title}</h2>
        {children}
      </div>
    </div>
  );
}
